import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { BackgroundImage } from '../models/background-image.model';
import { ExternalPortalConfig } from '../models/external-portal-config.model';

@Injectable({
  providedIn: 'root',
})
export class PortalHttpService {
  private baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getDefaultBackgroundImages(): Observable<BackgroundImage[]> {
    const url = `${this.baseUrl}backgroundimages/current`;
    return this.http.get<BackgroundImage[]>(url);
  }

  getExternalPortalConfiguration(): Observable<ExternalPortalConfig> {
    const url = `${this.baseUrl}externalportalconfiguration`;
    return this.http.get<ExternalPortalConfig>(url);
  }
}
